<template>
  <div class="customerTemplate">
    <div v-if="customerTabStat !== 'ALL'">
      <customer-tab
      ref="customerTab"
      :customerTabStat='customerTabStat'
      :pagination="pagination"
      @dialogOpen="dialogManagement"
      @groupSeting="groupSeting"
      @resetParam="resetParam"
      @updateSearchOption="updateSearchOption"
      >
      </customer-tab>
      <group-dialog
      :dialogType="dialogType"
      :dialog="dialog"
      :customerAreaList="customerAreaList"
      :customerUseOsList="customerUseOsList"
      :customerTagsList="customerTagsList"
      :customerStat="customerTabStat"
      :selectGroupId="selectGroupId"
      :webChatModuleChannelId="webChatModuleChannelId"
      @dialogClose="groupDialogManagement"
      @getGroupListPass="getGroupListPass"
      ></group-dialog>
      <customer-send-dialog
      :sendDialog="sendDialog"
      :sendCustomerList="sendCustomerList"
      :mailSendCheck="mailSendCheck"
      :customerTabStat="customerTabStat"
      @sendDialogClose="sendDialogClose"
      >
      </customer-send-dialog>
    </div>
    <div class="content layer">
      <div class="pageTit">
        <dl>
          <dt>{{headerTitle}}</dt>
          <dd>{{headerDescription}}</dd>
        </dl>
        <div class="brandBox">
          <brand-select></brand-select>
        </div>
      </div>
      <div>
        <table class="tbl form-table">
          <colgroup>
            <col style="width:140px" />
            <col />
            <col style="width:140px" />
            <col />
          </colgroup>
          <tbody>
            <tr v-if="customerTabStat === 'LINE'">
              <th>チャネル</th>
              <td>
                <v-select
                    v-model="lineChannel"
                    :items="lineChannelList"
                    item-text="name"
                    item-value="value"
                    placeholder="ラインチャネル"
                    class="UXselect"
                    hide-details
                    outline
                    solo
                    attach
                    no-data-text="データがありません。"
                ></v-select>
              </td>
              <td colspan="2"></td>
            </tr>
            <tr>
              <th>最終接続日時</th>
              <td colspan="3" class="td-calendar">
                <div class="dateInp">
                  <div class="pickerBox" style="bottom: 0px !important; padding-left: 0px !important;">
                    <div class="dateInp" :class="{ 'opacity': isDateTypeAll }">
                      <date-picker :startDate="startDate" :endDate="endDate" :disabledDates="['afterToday']" @child="updateDatePicker" class="date-picker" v-show="startDate !== ''"></date-picker>
                      <v-btn-toggle v-model="dateBtn" class="UXbtnToggle date-picker-btn">
                        <v-btn flat @click="changStartData(0, 'days')" value="0" :disabled="dateBtn === '0'">
                          <span>今日</span>
                        </v-btn>
                        <v-btn flat @click="changStartData(7, 'days')" value="6" :disabled="dateBtn === '6'">
                          <span>7日</span>
                        </v-btn>
                        <v-btn flat @click="changStartData(1, 'month')" value="30" :disabled="dateBtn === '30'">
                          <span>1ヶ月</span>
                        </v-btn>
                        <v-btn flat @click="changStartData(3, 'month')" value="90" :disabled="dateBtn === '90'">
                          <span>3ヶ月</span>
                        </v-btn>
                        <v-btn flat @click="changStartData(6, 'month')" value="180" :disabled="dateBtn === '180'">
                          <span>6ヶ月</span>
                        </v-btn>
                        <v-btn flat @click="changStartData(-1, 'ALL')" value="-1" :disabled="dateBtn === '-1'">
                          <span>全体</span>
                        </v-btn>
                      </v-btn-toggle>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>検索キーワード</th>
              <td>
                <v-text-field
                  v-model="customerKeyword"
                  append-icon="search"
                  placeholder="名前/電話番号/メールアドレス検索"
                  @keyup.enter.exact="getCustomerSearch(1)"
                  class="UXinput UXicon-search"
                  hide-details
                  outline
                  solo
                ></v-text-field>
            </td>
            <th>検索条件追加</th>
            <td>
              <v-radio-group hide-details row class="UXradio" v-model="filterUse" @change="searchNotUse()">
                <v-radio label="追加する" :value="true"></v-radio>
                <v-radio label="追加しない" :value="false"></v-radio>
              </v-radio-group>
            </td>
          </tr>
          <tr v-if="filterUse">
            <th>会員ID</th>
            <td>
              <v-text-field
                v-model="customerMemberId"
                @keyup.enter.exact="getCustomerSearch(1)"
                append-icon="search"
                placeholder="会員ID"
                class="UXinput UXicon-search"
                hide-details
                outline
                solo
              ></v-text-field>
            </td>
            <th>タグ</th>
            <td>
              <v-autocomplete
                ref="tagInp"
                v-model="customerTags"
                :items="customerTagsList"
                item-text="name"
                item-value="value"
                class="UXselect"
                outline
                multiple
                chips
                small-chips
                hide-no-data
                placeholder="タグ検索"
                ></v-autocomplete>
            </td>
          </tr>
            <tr v-if="filterUse">
              <th>会員状態</th>
              <td>
                <v-checkbox
                  v-model="customerMemberFlg"
                  value="ENABLE"
                  label="会員"
                  class="UXcheckbox gray left"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="customerMemberFlg"
                  value="DISABLE"
                  label="非会員"
                  class="UXcheckbox gray left"
                  hide-details
                  ></v-checkbox>
                </td>
                <th>メモ</th>
                <td>
                  <v-text-field
                  v-model="customerDetail"
                  @keyup.enter.exact="getCustomerSearch(1)"
                  class="UXinput UXicon-search"
                  outline
                  hide-details
                  solo
                  placeholder="メモ検索"
                ></v-text-field>
              </td>
            </tr>
            <tr v-if="filterUse && customerTabStat !== 'LINE'">
              <th>エリア</th>
              <td>
                <v-autocomplete
                  v-model="customerArea"
                  :items="customerAreaList"
                  item-text="name"
                  item-value="value"
                  class="UXselect"
                  outline
                  multiple
                  chips
                  small-chips
                  hide-no-data
                  placeholder="エリア検索"
              ></v-autocomplete>
              </td>
              <th>使用OS</th>
              <td>
                <v-autocomplete
                  v-model="customerUseOs"
                  :items="customerUseOsList"
                  item-text="name"
                  item-value="value"
                  class="UXselect"
                  outline
                  multiple
                  chips
                  small-chips
                  hide-no-data
                  placeholder="使用OS検索"
                ></v-autocomplete>
              </td>
            </tr>
            <tr v-if="filterUse && customerTabStat !== 'LINE'">
              <th>問合せ数</th>
              <td>
                <v-select
                  v-model="accessCount"
                  :items="accessCountList"
                  item-text="name"
                  item-value="value"
                  class="UXselect type-select"
                  placeholder="問合せ数検索"
                  hide-details
                  outline
                  multiple
                  chips
                  small-chips
                  no-data-text="データがありません。"
                ></v-select>
              </td>
            </tr>
            <tr v-if="filterUse && customerTabStat === 'LINE'">
              <th>性別</th>
              <td>
                <v-checkbox
                  v-model="customerGenderInfo"
                  value="MALE"
                  label="男性"
                  class="UXcheckbox gray left"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="customerGenderInfo"
                  value="FEMALE"
                  label="女性"
                  class="UXcheckbox gray left"
                  hide-details
                  ></v-checkbox>
                </td>
              <th>年齢</th>
              <td>
                <v-autocomplete
                  ref="tagInp"
                  v-model="customerAgeInfo"
                  :items="customerAgeInfoList"
                  item-text="name"
                  item-value="value"
                  class="UXselect"
                  outline
                  multiple
                  chips
                  small-chips
                  hide-no-data
                  placeholder="平均利用額検索"
                  ></v-autocomplete>
              </td>
            </tr>
            <tr v-if="filterUse && customerTabStat === 'LINE'">
              <th>訪問数</th>
              <td>
                <v-autocomplete
                  ref="tagInp"
                  v-model="visitCount"
                  :items="visitCountList"
                  item-text="name"
                  item-value="value"
                  class="UXselect"
                  outline
                  multiple
                  chips
                  small-chips
                  hide-no-data
                  placeholder="訪問数検索"
                  ></v-autocomplete>
              </td>
              <th>平均利用額</th>
              <td>
                <v-autocomplete
                  ref="tagInp"
                  v-model="avgAmount"
                  :items="avgAmountList"
                  item-text="name"
                  item-value="value"
                  class="UXselect"
                  outline
                  multiple
                  chips
                  small-chips
                  hide-no-data
                  placeholder="平均利用額検索"
                  ></v-autocomplete>
              </td>
            </tr>
            <tr v-if="filterUse && customerTabStat === 'LINE'">
              <th>エリア</th>
              <td>
                <v-autocomplete
                  v-model="customerArea"
                  :items="customerAreaList"
                  item-text="name"
                  item-value="value"
                  class="UXselect"
                  outline
                  multiple
                  chips
                  small-chips
                  hide-no-data
                  placeholder="エリア検索"
                ></v-autocomplete>
              </td>
              <th>問合せ数</th>
              <td>
                <v-select
                  v-model="accessCount"
                  :items="accessCountList"
                  item-text="name"
                  item-value="value"
                  class="UXselect type-select"
                  placeholder="問合せ数検索"
                  hide-details
                  outline
                  multiple
                  chips
                  small-chips
                  no-data-text="データがありません。"
                ></v-select>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="cenBtn btn-box">
          <v-btn outline small style="width: 100px;" class="UXbtn widthAuto" @click="resetParamSearch">初期化</v-btn>
          <v-btn dark small color="#ff8c8c" style="width: 100px;" class="UXbtn widthAuto" @click="getCustomerSearch(1)">検索</v-btn>
        </div>
      </div>
      <div class="subBox">
        <div class="listBox">
          <div class="listHeader">
            <div class="left">
              <p>顧客({{pagination.totalElements}})</p>
            </div>
            <div class="right">
              <v-btn
                flat
                color="#2E7D32"
                class="UXdownload"
                :class="{ 'disabled-btn' : excelDownloading || noData }"
                :loading="excelDownloading"
                :disabled="!isPermission.export || excelDownloading || noData"
                @click="validateExcelDownload()">
                <img src="//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/uxicon-excel.png"/>Excelのエクスポート
                <span class="loadTxt" slot="loader">DownLoading...</span>
              </v-btn>
              <v-select
                item-value="code"
                item-text="name"
                v-model="currentListSize"
                @change="getCustomerSearch(1)"
                :items="listSize"
                class="UXselect sizeWid ml-10"
                hide-details
                outline
                solo
                no-data-text="データがありません。"
              ></v-select>
            </div>
          </div>
          <div class="orderBox">
            <ul>
              <li v-for="item in orderList" :key="item.key" @click="orderClick(item)" :class="{'unselect' : item.key !== order, 'down': item.ascending}">
                {{ item.value }}
              </li>
            </ul>
          </div>
          <!-- <table-top-buttons :header-buttons="headerButtons" :button-event="buttonEvent"></table-top-buttons> -->
          <table-top-buttons :header-buttons="headerButtons" :button-event="buttonEvent"></table-top-buttons>
          <div class="listTblCon">
            <div class="listTableArea">
              <table class="listTbl data-table" :class="noData ? 'noData' : ''">
                <colgroup>
                  <col v-for="(k, index) in headers" :key="index" :style="{ width: k.width }"/>
                </colgroup>
                <thead>
                  <tr>
                    <th v-for="(k, index) in headers" :key="index" :class="{'th-text': !k.isCheckbox, 'th-checkbox': k.isCheckbox}">
                      <span v-html="k.text" v-if="!k.isCheckbox"></span>
                      <v-checkbox
                        v-else
                        class="UXcheckbox gray"
                        v-model="checkedAll"
                        @change="checkedAllChange"
                        hide-details
                        solo
                      ></v-checkbox>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(customer, index) in customerList" :key="index" class="customer-list-tr">
                    <td class="td-checkbox">
                      <div>
                        <span v-if="!customer.isCheckbox" class="gray-6--text">-</span>
                        <v-checkbox
                          v-else
                          class="UXcheckbox gray"
                          v-model="customer.selected"
                          hide-details
                          solo
                          @change="checkedChange"
                          :disabled="disabled"
                        ></v-checkbox>
                      </div>
                    </td>
                    <td @click="customerInfo(customer)" class="td-list">
                      <div class="channelBox"
                        v-html="customer.channel || '-'"
                      ></div>
                    </td>
                    <td @click="customerInfo(customer)" class="td-list" v-if="customerTabStat === 'LINE'">
                        <div class="channelBox" v-if="customer.displayIconUrl"
                          v-html="customer.displayIconUrl"
                        ></div>
                        <div class="channelBox" v-else-if="!customer.displayIconUrl">
                          <i class="UXicon-person"></i>
                        </div>
<!--                      <div class="channelBox">-->
<!--                        <img v-if="customer.displayIconUrl && !displayIcon" :src="customer.displayIconUrl" alt="Customer Icon" @error="onImageError">-->
<!--                        <img :src="customer.displayIconUrl" alt="Customer Icon">-->
<!--                        <i v-if="displayIcon || !customer.displayIconUrl" class="UXicon-person"></i>-->
<!--                      </div>-->
                    </td>
                    <td @click="customerInfo(customer)" class="td-no">
                      <div class="box-30 flex-center">
                        {{ customer.area || '-' }}
                      </div>
                    </td>
                    <td @click="customerInfo(customer)" class="td-list" v-if="customerTabStat !== 'LINE'">
                      <div class="box-40 flex-center">
                        {{ customer.memberFlg || '-' }}
                      </div>
                    </td>
                    <td @click="customerInfo(customer)" class="td-list">
                      <div class="clamp-control flex-center">
                        <div class="clampInTable flex-center">{{ customer.memberId || '-' }}</div>
                        <div class="clampInTable emailBold flex-center">{{ customer.email || '-'}}</div>
                        <div class="clampInTable flex-center">{{ customer.phoneNumber || '-' }}</div>
                      </div>
                    </td>
                    <td @click="customerInfo(customer)" class="td-list">
                      <div class="clamp-control flex-center">
                        <div class="clampInTable flex-center">{{ customer.name || '-' }}</div>
                        <div class="clampInTable flex-center" v-if="customerTabStat === 'LINE'">{{ customer.gender || '-'}} / {{ customer.age + '歳' || '-'}}</div>
                      </div>
                    </td>
                    <td @click="customerInfo(customer)" class="td-list">
                      <div v-if="customer.moduleChannelName !== 'LINE'" class="box-40 flex-center">
                        -
                      </div>
                      <div v-else class="box-40 flex-center">
                        {{ customer.visitCount || 0 }}
                      </div>
                    </td>
                    <td @click="customerInfo(customer)" class="td-list">
                      <div v-if="customer.moduleChannelName !== 'LINE'" class="box-40 flex-center">
                        -
                      </div>
                      <div v-else class="box-40 flex-center">
                        {{ customer.avgAmount || 0 }}
                      </div>
                    </td>
                    <td @click="customerInfo(customer)" class="td-list">
                      <div class="box-40 flex-center">
                        {{ customer.accessCount || '-' }}
                      </div>
                    </td>
                    <td @click="customerInfo(customer)" class="td-list">
                      <div
                        class="box-40"
                        v-html="customer.lastVisitDate || '-'"
                      ></div>
                    </td>
                    <td @click="customerInfo(customer)" class="td-list">
                      <div class="flex-center clamp-control">
                        {{ customer.memo || '-' }}
                      </div>
                    </td>
                    <td @click="customerInfo(customer)">
                      <div class="flex-center">
                        <div v-if="!customer.tag">-</div>
                        <div v-else class="tagsList inlineFlex">
                          <p v-for="(name, index) in customer.tag" :key="index"><span class="clampTxt line-clamp-1">{{name}}</span></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="noData" class="UXnotData large" style="height:375px">
                リストがありません。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pagination
      v-model="pagination.page"
      :length="pagination.totalPages"
      @input="getCustomerSearch"
  ></pagination>
  <Dimmed :is-show="isFuncLv1" title="現在のプランではご利用できません。">
    <div class="brand-module-box">
      <span>プランを変更後ご利用お願いします。</span>
    </div>
  </Dimmed>
  <excel-password-dialog v-model="excel" :excel-download="excelDownload"></excel-password-dialog>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import moment from 'moment'
import helpers from '../../../../util/helpers'
import util from '../../../../util/'
import BrandSelect from '@/components/BrandSelect'
import tableTopButtons from './tableTopButtons'
import customerTab from './customerTab'
import groupDialog from './groupDialog'
import permissions from '@/util/permissions'
import excelPasswordDialog from '@/components/dialog/excel_password_dialog'
import customerSendDialog from './customerSendDialog'
import Dimmed from '@/components/Dimmed'
import lineFriendReport from '../../../dashboard/fragments/lineFriendReport.vue'

export default {
  metaInfo: {
    title: '顧客情報'
  },
  props: {
    headerTitle: String,
    headerDescription: String,
    customerTabStat: String
  },
  components: {
    lineFriendReport,
    BrandSelect,
    tableTopButtons,
    customerTab,
    groupDialog,
    excelPasswordDialog,
    customerSendDialog,
    Dimmed
  },
  data () {
    return {
      order: 'recentAccess',
      ascending: false,
      customerSize: 15,
      customerKeyword: '',
      excelDownloading: false,
      filterUse: false,
      disabled: false,
      customerId: '',
      customerTags: '',
      customerTagsList: [],
      customerArea: [],
      customerAreaList: [],
      customerUseOs: [],
      customerUseOsList: [],
      customerUseWeb: '',
      customerUseWebList: [],
      customerMemberId: '',
      customerDetail: '',
      customerDetailList: [],
      customerMemberFlg: ['ENABLE', 'DISABLE'],
      usingType: 'SHOW',
      startDate: '',
      endDate: '',
      dateBtn: '-1',
      pagination: {
        page: 1,
        size: 15,
        totalPages: '',
        totalElements: 0
      },
      currentListSize: {name: '15個', code: 15},
      listSize: [
        {name: '15個', code: 15},
        {name: '30個', code: 30},
        {name: '50個', code: 50},
        {name: '100個', code: 100}
      ],
      headers: this.headersColumn(),
      customerList: [],
      searchType: '',
      searchList: [
        {value: '', name: '全体'},
        {value: 'QUESTION', name: 'テンプレート名'},
        {value: 'ANSWER', name: 'テンプレート内容'}
      ],
      searchData: '',
      list: [],
      checkedAll: '',
      dialogType: '',
      dialog: false,
      dialogReset: false,
      keyList: ['create', 'update', 'export'],
      isPermission: {
        create: false,
        update: false,
        export: false
      },
      pmsKey: {
        create: 'CREATE_CUSTOMER',
        update: 'UPDATE_CUSTOMER',
        export: 'EXPORT_CUSTOMER'
      },
      excel: {
        excelComment: '',
        password: null,
        passwordConfirm: ''
      },
      selectGroupId: '',
      firstGroupSearch: false,
      sendDialog: false,
      sendCustomerList: [],
      mailSendCheck: false,
      accessCount: [],
      accessCountList: [
        {name: '0 - 5回', value: '0'},
        {name: '6 - 20回', value: '6'},
        {name: '21 - 99回', value: '21'},
        {name: '100回以上', value: '100'}
      ],
      visitCount: [],
      visitCountList: [
        {name: '0 - 1回', value: '0'},
        {name: '2 - 9回', value: '2'},
        {name: '10回以上', value: '10'}
      ],
      avgAmount: [],
      avgAmountList: [
        {name: '0 - 1,000円', value: '0'},
        {name: '1,001 - 10,000円', value: '1001'},
        {name: '10,001円以上', value: '10001'}
      ],
      lineStatus: false,
      mailStatus: false,
      lineChannel: null,
      lineChannelList: [{
        name: '全体',
        value: null
      }],
      friendFlg: false,
      webChatModuleChannelId: null,
      customerGenderInfo: [],
      customerAgeInfo: [],
      displayIcon: false,
      customerAgeInfoList: [
        {name: '14歳以下', value: '14'},
        {name: '15 - 19歳', value: '15'},
        {name: '20 - 24歳', value: '20'},
        {name: '25 - 29歳', value: '25'},
        {name: '30 - 34歳', value: '30'},
        {name: '35 - 39歳', value: '35'},
        {name: '40 - 44歳', value: '40'},
        {name: '45 - 49歳', value: '45'},
        {name: '50歳以上', value: '50'}
      ]
    }
  },
  computed: {
    ...mapGetters(['currentBrandId', 'isFuncLv1']),
    isDateTypeAll () {
      return this.dateBtn === '-1'
    },
    noData () {
      return this.customerList.length === 0
    },
    headerButtons () {
      if (this.customerTabStat === 'LINE') {
        return [
          {text: '一回のみ配信', isRight: true, isSend: true, isDisabled: this.customerTabStat === 'ALL' || !this.isBtnSend()}
        ]
      } else {
        return [
          // {text: (this.customerTabStat !== 'LINE' ? '友達連動' : '新規'), isRight: true, isSave: true, isDisabled: !this.isPermission['create'] || this.customerTabStat === 'ALL' || (this.customerTabStat === 'WEBSITE' && !this.mailStatus) || (this.customerTabStat === 'LINE' && !this.lineStatus)},
          // {text: '新規', isRight: true, isSave: true, isDisabled: !this.isPermission['create'] || this.customerTabStat === 'ALL' || (this.customerTabStat === 'WEBSITE' && !this.mailStatus)},
          {text: '一回のみ配信', isRight: true, isSend: true, isDisabled: this.customerTabStat === 'ALL' || !this.isBtnSend()}
        ]
      }
    },
    orderList () {
      return [
        {key: 'recentAccess', value: '最終接続', ascending: false},
        {key: 'sessionCount', value: '問合せ数', ascending: false},
        {key: 'memberId', value: 'ID', ascending: false},
        {key: 'memberFlg', value: '会員状態', ascending: false}
      ]
    },
    channelType () {
      if (this.customerTabStat === 'WEBSITE') {
        return 'WEB_CHAT'
      } else {
        return this.customerTabStat
      }
    }
  },
  created () {
    this.checkPermission()
    this.setCustomerListOption()
  },
  mounted () {
    window.scrollTo(0, 0)
    this.brandId = this.currentBrandId
    this.systemMaster()
    this.getTagList()
    this.getCustomerSearch(this.pagination.page)
    this.getChannels()
    this.getLineChannelList()
  },
  watch: {
    lineChannel () {
      this.getCustomerSearch(1)
    }
  },
  methods: {
    headersColumn () {
      let sectionHeadName = ''
      if (this.customerTabStat === 'LINE') {
        sectionHeadName = '問合せ数'
      } else if (this.customerTabStat === 'WEBSITE') {
        sectionHeadName = '問合せ数'
      } else {
        sectionHeadName = '問合せ数'
      }
      const headers = [
        {text: '', width: '35px', isCheckbox: true},
        {text: 'チャネル', width: '50px'},
        {text: 'エリア', width: '80px'},
        {text: '会員ＩＤ<br/>メールアドレス<br/>電話番号', width: '140px'},
        {text: '訪問数', width: '40px'},
        {text: '平均利用額', width: '80px'},
        {text: sectionHeadName, width: '50px'},
        {text: '最終接続日', width: '100px'},
        {text: 'メモ', width: '80px'},
        {text: 'タグ', width: '80px'}
      ]
      if (this.customerTabStat === 'LINE') {
        const lineUserIconHeader = {text: 'ユーザー', width: '60px'}
        headers.splice(2, 0, lineUserIconHeader)
      }
      if (this.customerTabStat !== 'LINE') {
        const member = {text: '会員状態', width: '80px'}
        headers.splice(3, 0, member)
      }
      if (this.customerTabStat === 'LINE') {
        const lineUserHeader = {text: '名前<br />性別・年齢', width: '80px'}
        headers.splice(5, 0, lineUserHeader)
      }
      if (this.customerTabStat !== 'LINE') {
        const lineUserHeader = {text: '名前', width: '80px'}
        headers.splice(5, 0, lineUserHeader)
      }
      return headers
    },
    groupSeting (item) {
      let groupType = item.groupType
      this.selectGroupId = item.selectGroupId
      this.firstGroupSearch = item.firstSearch
      if (groupType === 'SetAsIs') {
        this.$alertMsg('グループが変更されました。')
      } else if (groupType === 'ChangeSetting') {
        this.dialogManagement(groupType, true, false)
      }
      if (this.firstGroupSearch) {
        if (item.searchData) {
          this.setingGroupParam(item.searchData)
        } else {
          this.filterUse = false
        }
        this.getCustomerSearch()
      }
    },
    buttonEvent (button) {
      const checkList = this.customerList.filter(f => f.selected)
      if (button.isSave) {
        this.$router.push({ path: `/customer/customerRegister`,
          query: {
            permissons: this.isPermission.create,
            customerStat: this.customerTabStat
          }
        })
      } else if (button.isSend) {
        this.sendDialog = true
        this.mailSendCheck = checkList.filter(f => f.email === '').length === 0
        this.sendCustomerList = checkList.map(d => d.customerId)
      }
    },
    excelDownload () {
      this.isExcelDownloading = true
      const startDate = this.startDate === '' ? '' : this.startDate
      const endDate = this.endDate === '' ? '' : this.endDate
      this.axios.get(`/api/customer/customerList/excel?` +
      `customerId=${encodeURIComponent(this.customerMemberId)}` +
      `&customerKeyword=${encodeURIComponent(this.customerKeyword)}` +
      `&excelComment=${encodeURIComponent(this.excel.excelComment)}` +
      `&password=${encodeURIComponent(this.excel.password)}`, {
        params: {
          brandId: this.currentBrandId,
          searchFrom: startDate,
          searchTo: endDate,
          customerUseOs: encodeURI(this.getSelectedArrayValue(this.customerUseOs)),
          customerUseWeb: this.customerUseWeb,
          customerUseArea: encodeURI(this.getSelectedArrayValue(this.customerArea)),
          customerMemberFlg: encodeURI(this.getSelectedArrayValue(this.customerMemberFlg)),
          customerDetail: this.customerDetail,
          customerTag: encodeURI(this.getSelectedArrayValue(this.customerTags)),
          accessCount: encodeURI(this.getSelectedArrayValue(this.accessCount)),
          visitCount: encodeURI(this.getSelectedArrayValue(this.visitCount)),
          avgAmount: encodeURI(this.getSelectedArrayValue(this.avgAmount)),
          order: this.order,
          ascending: this.ascending,
          customerStat: this.channelType,
          age: encodeURI(this.getSelectedArrayValue(this.customerAgeInfo)),
          gender: encodeURI(this.getSelectedArrayValue(this.customerGenderInfo))
        }
      }).then((res) => {
        if (res.data.code !== 0) {
          throw res.data.message
        } else {
          this.getExcelFile(res.data)
        }
      })
    },
    validateExcelDownload () {
      this.$eventBus.$emit('excelPasswordDialog', {useDialog: true})
    },
    getExcelFile (response) {
      let link = document.createElement('a')
      if (response) {
        link.href = response.data
        link.target = '_self'
        link.click()
      } else {
        this.$toasted.error(`Excelのエクスポートエラー`)
      }
      this.excelDownloading = false
    },
    systemMaster () {
      this.axios.get('/api/systemMaster/findByBrand', {
        params: {
          brandId: this.currentBrandId
        }
      }).then(result => {
        if (result.status !== 200 || result.data.code !== 0) {
          console.log(result.data.message)
        } else {
          let data = result.data.data
          data.forEach(list => {
            if (list.type === 'AREA') {
              this.customerAreaList.push({value: list.code, name: list.value})
            } else if (list.type === 'OS') {
              this.customerUseOsList.push({value: list.code, name: list.value})
            }
          })
        }
      }).catch(err => {
        console.log(err.message)
      })
    },
    getTagList () {
      this.axios.get('/api/customerTag', {
        params: {
          brandId: this.currentBrandId
        }
      }).then(result => {
        if (result.status !== 200 || result.data.code !== 0) {
          console.log(result.data.message)
        } else {
          let data = result.data.data
          data.forEach(list => {
            this.customerTagsList.push({value: list.code, name: list.value})
          })
        }
      }).catch(err => {
        console.log(err.message)
      })
    },
    getSelectedArrayValue (covertData) {
      const arrayData = []
      if (covertData) {
        covertData.forEach((i) => {
          arrayData.push(i)
        })
      }
      return arrayData
    },
    getCustomerSearch (page) {
      if (page) {
        this.pagination.page = page
      }
      this.pagination.size = this.currentListSize.code || this.currentListSize
      const startDate = this.startDate === '' ? '' : this.startDate
      const endDate = this.endDate === '' ? '' : this.endDate
      this.$http.get(`/api/customer/searchCustomerInfoData?` +
      `customerId=${encodeURIComponent(this.customerMemberId)}` +
      `&customerKeyword=${encodeURIComponent(this.customerKeyword)}`, {
        params: {
          brandId: this.currentBrandId,
          moduleChannelId: this.lineChannel,
          searchFrom: startDate,
          searchTo: endDate,
          customerUseOs: encodeURI(this.getSelectedArrayValue(this.customerUseOs)),
          customerUseWeb: this.customerUseWeb,
          customerUseArea: encodeURI(this.getSelectedArrayValue(this.customerArea)),
          customerMemberFlg: encodeURI(this.getSelectedArrayValue(this.customerMemberFlg)),
          customerDetail: this.customerDetail,
          customerTag: encodeURI(this.getSelectedArrayValue(this.customerTags)),
          accessCount: encodeURI(this.getSelectedArrayValue(this.accessCount)),
          visitCount: encodeURI(this.getSelectedArrayValue(this.visitCount)),
          avgAmount: encodeURI(this.getSelectedArrayValue(this.avgAmount)),
          genderInfo: encodeURI(this.getSelectedArrayValue(this.customerGenderInfo)),
          ageInfo: encodeURI(this.getSelectedArrayValue(this.customerAgeInfo)),
          order: this.order,
          ascending: this.ascending,
          customerStat: this.channelType,
          page: this.pagination.page,
          size: this.pagination.size
        }
      }).then(result => {
        if (result.status !== 200 || result.data.code !== 0) {
          console.log(result.data.message)
        } else {
          this.updateSearchOption()
          this.firstGroupSearch = false
          let data = result.data.data
          this.customerList = []
          this.pagination.totalElements = result.data.totalElements
          this.pagination.totalPages = Math.ceil(result.data.totalElements / this.pagination.size)

          data.forEach(d => {
            const cust = {
              selected: false,
              isCheckbox: true,
              customerId: d.customerId,
              area: d.areaName,
              accessCount: d.accessCount,
              lastVisitDate: d.lastVisitDate ? `<span>${helpers.convertDateTimeToYYYYMMDDwithHyphen(d.lastVisitDate)}</span>
            <br/>
            <span class="gray-7--text">${helpers.printTimeStampFromDateTimeWithoutAP(d.lastVisitDate)}</span>` : null,
              memberId: d.memberId,
              memberFlg: d.memberId ? '会員' : '非会員',
              channel: `<img src=${d.channelReplacedIconUrl ? d.channelReplacedIconUrl : util.getChatRoomIcon(d.moduleChannelName)} width="30"/>`,
              email: d.email,
              phoneNumber: d.phoneNumber,
              name: d.name,
              section: d.section,
              date: d.date,
              memo: d.memo,
              tag: d.customerTagName,
              moduleChannelName: d.moduleChannelName,
              moduleChannelId: d.moduleChannelId,
              visitCount: d.visitCount,
              avgAmount: d.avgAmount,
              displayIconUrl: d.displayIconUrl,
              displayIcon: false, // 초기값 설정
              friendFlg: d.friendFlg,
              age: d.age,
              gender: d.gender
            }
            // 이미지 URL의 접근 권한 확인
            if (d.displayIconUrl) {
              const img = new Image()
              img.src = d.displayIconUrl
              img.onload = () => {
                cust.displayIcon = false // 이미지 로드 성공
                cust.displayIconUrl = `<img src=${d.displayIconUrl} width="30"/>`
                this.customerList.push(cust)
              }
              img.onerror = () => {
                cust.displayIcon = true // 이미지 로드 실패
                cust.displayIconUrl = null
                this.customerList.push(cust)
              }
            } else {
              cust.displayIcon = true
              cust.displayIconUrl = null
              this.customerList.push(cust)
            }
          })
          // data.forEach(d => {
          //   this.customerList.push({
          //     selected: false,
          //     isCheckbox: true,
          //     customerId: d.customerId,
          //     area: d.areaName,
          //     accessCount: d.accessCount,
          //     lastVisitDate: d.lastVisitDate ? `<span>${helpers.convertDateTimeToYYYYMMDDwithHyphen(d.lastVisitDate)}</span>
          //             <br/>
          //             <span class="gray-7--text">${helpers.printTimeStampFromDateTimeWithoutAP(d.lastVisitDate)}</span>` : null,
          //     memberId: d.memberId,
          //     memberFlg: d.memberId ? '会員' : '非会員',
          //     channel: `<img src=${d.channelReplacedIconUrl ? d.channelReplacedIconUrl : util.getChatRoomIcon(d.moduleChannelName)} width="30"/>`,
          //     email: d.email,
          //     phoneNumber: d.phoneNumber,
          //     name: d.name,
          //     section: d.section,
          //     date: d.date,
          //     memo: d.memo,
          //     tag: d.customerTagName,
          //     moduleChannelName: d.moduleChannelName,
          //     moduleChannelId: d.moduleChannelId,
          //     visitCount: d.visitCount,
          //     avgAmount: d.avgAmount,
          //     displayIconUrl: d.displayIconUrl ? `<img src=${d.displayIconUrl} width="30"/>` : null,
          //     friendFlg: d.friendFlg,
          //     age: d.age,
          //     gender: d.gender
          //   })
          //   // 이미지 URL의 접근 권한 확인
          //   if (d.displayIconUrl) {
          //     const img = new Image()
          //     img.src = d.displayIconUrl
          //     img.onload = () => {
          //       d.displayIcon = false // 이미지 로드 성공
          //       this.customerList.push(d)
          //     }
          //     img.onerror = () => {
          //       d.displayIcon = true // 이미지 로드 실패
          //       this.customerList.push(d)
          //     }
          //   } else {
          //     d.displayIcon = true
          //     this.customerList.push(d)
          //   }
          // })
          console.log(this.customerList)
          return this.customerList
        }
      }).catch(err => {
        console.log(err.message)
      })
    },
    customerInfo (item) {
      let pathUrl = this.customerTabStat === 'ALL' ? '/customer/customerInfo' : `/${this.customerTabStat.toLowerCase()}Customer/customerInfo`
      this.$router.push({ path: pathUrl,
        query: {
          customerId: item.customerId,
          pageType: 'UPDATE',
          permissons: this.isPermission.update,
          customerStat: item.moduleChannelName,
          moduleChannelId: item.moduleChannelId
        }
      })
    },
    checkedAllChange () {
      if (this.checkedAll) {
        this.customerList.map(d => {
          d.selected = true
        })
      } else {
        this.customerList.map(d => {
          d.selected = false
        })
      }
    },
    checkedChange () {
      const checkedArr = this.customerList.filter(f => {
        return f.selected
      })

      if (checkedArr.length === this.customerList.length) {
        this.checkedAll = true
      } else {
        this.checkedAll = false
      }
    },
    updateDatePicker (date) {
      this.dateBtn = ''
      this.startDate = date.start
      this.endDate = date.end
    },
    changStartData (day, type) {
      if (type === 'ALL') {
        this.startDate = ''
        this.endDate = ''
      } else {
        const now = this.$moment(new Date()).format('YYYY-MM-DD')
        if (day === 0 && type === 'days') {
          this.startDate = moment(now).subtract(day, type).format('YYYY-MM-DD')
        } else if (type === 'days') {
          this.startDate = moment(now).subtract(day, type).add(1, 'days').format('YYYY-MM-DD')
        } else {
          this.startDate = moment(now).subtract(day, type).format('YYYY-MM-DD')
        }
        this.endDate = moment(now).format('YYYY-MM-DD')
      }
    },
    dialogManagement (type, stat, reset) {
      this.dialogType = type
      this.dialog = stat
      this.dialogReset = reset
    },
    groupDialogManagement (type, stat, reset) {
      this.dialogType = 'New'
      this.dialog = false
      this.dialogReset = true
    },
    orderClick (item) {
      item.ascending = item.key === this.order ? !item.ascending : item.ascending
      this.order = item.key
      this.ascending = item.ascending
      this.getCustomerSearch(1)
    },
    resetParamSearch () {
      this.resetParam()
      this.getCustomerSearch(1)
    },
    resetParam () {
      this.startDate = ''
      this.endDate = ''
      this.customerKeyword = ''
      this.dateBtn = '-1'
      this.customerUseOs = []
      this.customerUseWeb = ''
      this.customerArea = []
      this.customerMemberId = ''
      this.customerMemberFlg = ['DISABLE', 'ENABLE']
      this.customerDetail = ''
      this.customerTags = ''
      this.order = 'recentAccess'
      this.ascending = 'false'
      this.customerTag = ''
      this.visitCount = ''
      this.avgAmount = ''
      this.accessCount = ''
      this.lineChannel = null
      this.customerAgeInfo = []
      this.customerGenderInfo = []
    },
    setingParam (params) {
      if (Object.keys(params).length) {
        this.startDate = params.startDate
        this.endDate = params.endDate
        this.customerKeyword = params.customerKeyword
        this.customerUseOs = params.customerUseOs
        this.customerUseWeb = params.customerUseWeb
        this.customerArea = params.customerArea
        this.customerMemberId = params.customerMemberId
        this.customerMemberFlg = params.customerMemberFlg
        this.customerDetail = params.customerDetail
        this.customerTags = params.customerTags
        this.order = params.order
        this.ascending = params.ascending
        this.customerTag = params.customerTag
        this.visitCount = params.visitCount
        this.avgAmount = params.avgAmount
        this.filterUse = params.filterUse
        this.pagination.page = params.page
        this.pagination.size = params.size
        this.currentListSize = params.size
        this.getCustomerSearch(params.page)
      } else {
        this.resetParam()
      }
    },
    setingGroupParam (params) {
      if (Object.keys(params).length) {
        this.customerUseOs = params.os
        this.customerArea = params.area
        this.customerMemberFlg = params.memberflg
        this.customerTags = params.tag
        this.filterUse = true
        this.accessCount = params.accessCount
        this.startDate = params.lastVisitDateTo
        this.endDate = params.lastVisitDateFrom
        this.visitCount = params.visitCount
        this.avgAmount = params.avgAmount
        this.lineChannel = params.moduleChannelId
        this.customerGenderInfo = params.customerGenderInfo
        this.customerAgeInfo = params.customerAgeInfo
      } else {
        this.resetParam()
      }
    },
    checkPermission () {
      this.keyList.map(item => {
        this.isPermission[item] = permissions.checkAction(this.pmsKey[item])
      })
    },
    findValueAndMoveToFirst (targetList, searchValue) {
      // 배열에서 항목을 찾아서 제일 처음으로 보냄
      const searchIndex = targetList.findIndex(function (element) {
        if (element.value === searchValue) {
          return true
        }
      })
      const moveValue = targetList[searchIndex]
      targetList.splice(searchIndex, 1)
      targetList.unshift(moveValue)
      return targetList
    },
    getGroupListPass (groupId) {
      this.resetKeywordAndDate()
      this.$refs.customerTab.getGroupList(groupId)
    },
    searchNotUse () {
      if (this.filterUse === false) {
        this.resetParam()
      }
    },
    setCustomerListOption () {
      const key = 'CUSTOMER_LIST_OPTION'
      const option = localStorage.getItem(key)
      if (!option) {
        localStorage.setItem(key, JSON.stringify(
          {
            ALL: {startDate: '', endDate: '', customerMemberFlg: ['DISABLE', 'ENABLE'], customerKeyword: '', customerDetail: '', customerMemberId: '', customerUseOs: [], customerArea: [], accessCount: [], customerUseWeb: '', customerTag: [], page: 1, size: 15, order: 'recentAccess', ascending: false, filterUse: false, dateBtn: '-1', selectGroupId: ''},
            LINE: {startDate: '', endDate: '', customerMemberFlg: ['DISABLE', 'ENABLE'], customerKeyword: '', customerDetail: '', customerMemberId: '', customerUseOs: [], customerArea: [], accessCount: [], customerUseWeb: '', customerTag: [], customerGenderInfo: [], customerAgeInfo: [], page: 1, size: 15, order: 'recentAccess', ascending: false, filterUse: false, dateBtn: '-1', selectGroupId: '', visitCount: [], avgAmount: []},
            WEBSITE: {startDate: '', endDate: '', customerMemberFlg: ['DISABLE', 'ENABLE'], customerKeyword: '', customerDetail: '', customerMemberId: '', customerUseOs: [], customerArea: [], accessCount: [], customerUseWeb: '', customerTag: [], page: 1, size: 15, order: 'recentAccess', ascending: false, filterUse: false, dateBtn: '-1', selectGroupId: ''}
          }
        ))
      } else {
        const jsonArr = JSON.parse(option)
        let tabStat = this.customerTabStat
        const data = jsonArr[tabStat]
        this.startDate = data.startDate
        this.endDate = data.endDate
        this.customerMemberFlg = data.customerMemberFlg
        this.customerKeyword = data.customerKeyword
        this.customerDetail = data.customerDetail
        this.customerMemberId = data.customerMemberId
        this.customerUseOs = data.customerUseOs
        this.customerArea = data.customerArea
        this.accessCount = data.accessCount
        this.customerUseWeb = data.customerUseWeb
        this.customerTags = data.customerTag
        this.pagination.page = data.page
        this.pagination.size = data.size
        this.order = data.order
        this.ascending = data.ascending
        this.filterUse = data.filterUse
        this.dateBtn = data.dateBtn
        this.visitCount = data.visitCount
        this.avgAmount = data.avgAmount
      }
    },
    updateSearchOption () {
      const key = 'CUSTOMER_LIST_OPTION'
      const option = localStorage.getItem(key)
      const jsonArr = JSON.parse(option)
      if (!localStorage.getItem(key)) {
        return false
      }
      let tabStat = this.customerTabStat
      let data = {startDate: this.startDate, endDate: this.endDate, customerMemberFlg: this.customerMemberFlg, customerKeyword: this.customerKeyword, customerDetail: this.customerDetail, customerMemberId: this.customerMemberId, customerUseOs: this.customerUseOs, customerArea: this.customerArea, accessCount: this.accessCount, customerUseWeb: this.customerUseWeb, customerTag: this.customerTags, size: this.pagination.size, page: this.pagination.page, order: this.order, ascending: this.ascending, filterUse: this.filterUse, dateBtn: this.dateBtn, selectGroupId: this.selectGroupId, visitCount: this.visitCount, avgAmount: this.avgAmount, lineChannel: this.lineChannel, customerGenderInfo: this.customerGenderInfo, age: this.customerAgeInfo}
      jsonArr[tabStat] = data
      console.log(data)
      console.log(jsonArr[tabStat])
      localStorage.setItem(key, JSON.stringify(jsonArr))
    },
    resetKeywordAndDate () {
      this.startDate = ''
      this.endDate = ''
      this.dateBtn = '-1'
      this.customerKeyword = ''
      this.customerDetail = ''
      this.customerMemberId = ''
    },
    isBtnSend () {
      return this.customerList.filter(f => {
        return f.selected
      }).length > 0
    },
    sendDialogClose () {
      this.sendDialog = false
    },
    getChannels () {
      this.$http({
        method: 'GET',
        url: '/api/brand/searchChannels',
        params: {
          brandId: this.brandId
        }
      }).then(result => {
        if (result.data.code === 0) {
          const res = result.data.data
          res.forEach(channel => {
            this.lineStatus = res.filter(c => c.name === 'LINE' && c.status === '認証完了').length > 0
            if (!this.mailStatus) {
              this.mailStatus = res.filter(c => c.name === 'MAIL' && JSON.parse(c.data).use).length > 0
            }
          })
          if (this.customerTabStat === 'WEBSITE') {
            this.searchWebChatModuleChannel(res)
          }
        } else {
          this.$alertMsg(result.data.message)
        }
      })
    },
    searchWebChatModuleChannel (res) {
      const webChatModule = res.find(d => d.name === 'WEB_CHAT')
      this.webChatModuleChannelId = webChatModule.id
    },
    getLineChannelList () {
      this.$http({
        method: 'GET',
        url: `/api/v2/module-channels/${this.brandId}/line`
      }).then(result => {
        const res = result.data
        if (res.code === 0) {
          res.data.forEach(d => {
            this.lineChannelList.push({
              name: d.nickName,
              value: d.id
            })
          })
        } else {
          this.$alertMsg(result.data.message)
        }
      }).catch(err => {
        this.$alertMsg(err)
      })
    },
    onImageError (event) {
      console.log('3')
      // 이미지 요소를 숨기기
      event.target.style.display = 'none'
      // 대체 아이콘을 표시하기 위한 로직 추가
      this.displayIcon = true
    }
  }
}
</script>

<style lang="scss">
.content .subBox {
  margin-top: 20px;
}
.clampInTable {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  margin-bottom: 4px;
}
.emailBold {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/menus/customer/components/customerList.vue